import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useEnquiryModal } from "./EnquiryModal";
import { useNavigate } from "react-router-dom";
import { LuxuryProjects } from "./Projects";

export default function OffPlanComponent() {
    const { openModal } = useEnquiryModal();
    const navigate = useNavigate();

    const handleCardClick = (property) => {
        navigate(`/new-projects/${property.url}`, { state: property });
    };
    return <>
        <section className="bg-[#ffffff] lg:py-0">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-12">
                {/* Header (Heading only on top for all views) */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 sm:mb-6">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#000000] text-start sm:text-left">
                        Off Plan Latest Launches
                    </h2>

                    {/* Desktop button (hidden on mobile) */}
                    <button
                        onClick={() => navigate("/new-projects")}
                        className="hidden sm:block border-2 border-[#0B1A3C] px-5 py-2 text-[#003153] rounded-lg text-md font-semibold hover:text-white hover:bg-[#003153] transition"
                    >
                        Explore off plan projects
                    </button>
                </div>

                {/* Responsive Property Grid */}
                <Swiper
                    modules={[Autoplay, Navigation]}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    loop={true}
                    // pagination={{ clickable: true }}
                    navigation={true}
                    spaceBetween={20}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {LuxuryProjects.map((p) => {

                        // --- Types compute logic ---
                        let types = [];
                        if (p.type) {
                            if (p.type.includes("&")) {
                                types = p.type.split("&").map(t => t.trim());
                            } else {
                                types.push(p.type);
                            }
                        }

                        return (
                            <SwiperSlide key={p.id} >
                                <div onClick={() => handleCardClick(p)} className="bg-white rounded-xl overflow-hidden shadow hover:shadow-lg transition cursor-pointer">
                                    <div className="relative">
                                        <img
                                            src={p.image}
                                            alt={p.title}
                                            className="w-full h-52 sm:h-56 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
                                        />
                                        <div className="absolute flex flex-col top-2 left-2 gap-2">
                                            <div className="flex gap-2 flex-wrap">
                                                {types.map((t, i) => (
                                                    <span
                                                        key={i}
                                                        className="bg-white text-[#003153] text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap"
                                                    >
                                                        {t}
                                                    </span>
                                                ))}
                                            </div>
                                            <span className="bg-[#003153] text-white text-[10px] font-semibold px-2 py-1 rounded whitespace-nowrap inline-block max-w-[120px] overflow-hidden text-ellipsis">
                                                {p.plan}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="p-4 sm:p-5">
                                        <h3 className="text-[#003153] text-3xl font-semibold leading-[32px] mb-3">
                                            {p.price}
                                        </h3>
                                        <p className="text-lg mb-0.5 font-medium">
                                            {p.title}
                                        </p>
                                        <h2 className="text-sm flex mb-3 items-center text-black">By {p.developer}</h2>
                                        <p className="text-sm text-[#003153] flex items-center">
                                            <i className="fa-solid fa-location-dot mr-1 text-[#003153]"></i>
                                            {p.location}
                                        </p>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation(); // card click prevent
                                                openModal({
                                                    projectTitle: p.project_name,   // THIS IS IMPORTANT
                                                    projectId: p.id,
                                                });
                                            }}
                                            className="w-full bg-[#003153] text-white font-semibold py-2 mt-4 rounded-lg text-sm sm:text-md hover:bg-[#003153]/90 transition"
                                        >
                                            Enquire Now
                                        </button>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                {/* Mobile button (shown only below carousel) */}
                <div className="block sm:hidden mt-4 text-center">
                    <button
                        onClick={() => navigate("/new-projects")}
                        className="border-2 border-[#0B1A3C] px-5 py-2 text-[#003153] rounded-lg text-md font-semibold hover:text-white hover:bg-[#003153] transition"
                    >
                        Explore off plan projects
                    </button>
                </div>
            </div>
        </section >
    </>;
}
